import React from 'react';

const SaleFlag = ({ show, discount }) => show &&
    discount && (React.createElement("div", { className: "sale-flag" },
    React.createElement("div", { className: "sale-flag-inner" }, discount)));

export { SaleFlag as S };
//# sourceMappingURL=SaleFlag-uqbhEU3Y.js.map
